import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

export const CostEstimationShell: React.FC = () => {
  return (
    <Box sx={{ display: "flex", height: "100%", width: "100%", flexDirection: "column" }}>
      <Outlet />
    </Box>
  );
};
